import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import InvoiceHistoryOrderListState from "@tKgpco/Store/Data/OrderHistory/InvoiceHistoryOrderListState";
import { Draft } from "immer";

const initialState: InvoiceHistoryOrderListState = {
    isLoading: false,
    invoiceList: [],
};
export const reducer = {
    "Custom/InvoiceHistoryOrderList/BeginLoad": (draft: Draft<InvoiceHistoryOrderListState>) => {
        draft.isLoading = true;
    },
    "Custom/InvoiceHistoryOrderList/CompleteLoad": (
        draft: Draft<InvoiceHistoryOrderListState>,
        action: InvoiceHistoryOrderListState,
    ) => {
        draft.isLoading = false;
        draft.invoiceList = action.invoiceList;
    },
    "Custom/InvoiceHistoryOrderList/FailedToLoadInvoiceHistoryOrderList": (draft: Draft<InvoiceHistoryOrderListState>) => {
        draft.isLoading = false;
        draft.invoiceList = [];
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
